// APIエンドポイント定義
// フロントエンド ↔ バックエンド間のRESTful APIエンドポイントを定義

const API_BASE_PATH = '/api';

// ============================================================================
// チャット管理API
// ============================================================================

export const ChatEndpoints = {
  // チャット一覧取得
  list: () => `${API_BASE_PATH}/chats`,
  
  // チャット詳細取得
  get: (chatId: string) => `${API_BASE_PATH}/chats/${chatId}`,
  
  // チャット作成
  create: () => `${API_BASE_PATH}/chats`,
  
  // チャット削除
  delete: (chatId: string) => `${API_BASE_PATH}/chats/${chatId}`,
  
  // 表示用メッセージ取得
  getMessages: (chatId: string) => `${API_BASE_PATH}/chats/${chatId}/messages`,
  
  // メッセージ送信
  sendMessage: (chatId: string) => `${API_BASE_PATH}/chats/${chatId}/messages`,
  
  // AI生成開始（非同期）
  startGeneration: (chatId: string) => `${API_BASE_PATH}/chats/${chatId}/generate`,
  
  // AI返答生成（同期）
  generateSync: (chatId: string) => `${API_BASE_PATH}/chats/${chatId}/generate-sync`,
} as const;

// ============================================================================
// セッション管理API
// ============================================================================

export const SessionEndpoints = {
  // セッション一覧取得
  list: () => `${API_BASE_PATH}/sessions`,
  
  // セッション作成
  create: () => `${API_BASE_PATH}/sessions`,
  
  // セッション削除
  delete: (sessionId: string) => `${API_BASE_PATH}/sessions/${sessionId}`,
  
  // 生成完了状態を確認
  checkGenerationStatus: (sessionId: string) => `${API_BASE_PATH}/sessions/${sessionId}/generation-status`,
  
  // AI生成を継続実行
  continueGeneration: (sessionId: string) => `${API_BASE_PATH}/sessions/${sessionId}/continue-generation`,
  
  // イベント取得
  getEvents: (sessionId: string, since?: number) => {
    const base = `${API_BASE_PATH}/sessions/${sessionId}/events`;
    return since ? `${base}?since=${since}` : base;
  },
} as const;

// ============================================================================
// ツリー操作API
// ============================================================================

export const TreeEndpoints = {
  // ツリー構造取得
  getStructure: (sessionId: string) => `${API_BASE_PATH}/sessions/${sessionId}/tree`,
  
  // ノード追加
  addNode: (sessionId: string) => `${API_BASE_PATH}/sessions/${sessionId}/nodes`,
  
  // ノード削除
  deleteNode: (sessionId: string, nodeId: string) => 
    `${API_BASE_PATH}/sessions/${sessionId}/nodes/${nodeId}`,
  
  // ノード選択（候補生成）
  selectNode: (sessionId: string, nodeId: string) => 
    `${API_BASE_PATH}/sessions/${sessionId}/nodes/${nodeId}/select`,
  
  // AI生成×10
  generateX10: (sessionId: string, nodeId: string) => 
    `${API_BASE_PATH}/sessions/${sessionId}/nodes/${nodeId}/generate-x10`,
  
  // AI生成×60
  generateX60: (sessionId: string, nodeId: string) => 
    `${API_BASE_PATH}/sessions/${sessionId}/nodes/${nodeId}/generate-x60`,
} as const;

// ============================================================================
// 設定管理API
// ============================================================================

export const SettingsEndpoints = {
  // デフォルト確率取得
  getDefaultProb: () => `${API_BASE_PATH}/settings/default-prob`,
  
  // デフォルト確率設定
  setDefaultProb: () => `${API_BASE_PATH}/settings/default-prob`,
  
  // モデル名取得
  getModelName: () => `${API_BASE_PATH}/settings/model-name`,
  
  // モデル名設定
  setModelName: () => `${API_BASE_PATH}/settings/model-name`,
  
  // モデル一覧取得
  getModelList: () => `${API_BASE_PATH}/settings/models`,
  
  // モデルタグ設定取得
  getModelTags: (modelName?: string) => {
    const base = `${API_BASE_PATH}/settings/model-tags`;
    return modelName ? `${base}?modelName=${encodeURIComponent(modelName)}` : base;
  },
} as const;

// ============================================================================
// WebSocketエンドポイント
// ============================================================================

export const WebSocketEndpoints = {
  // WebSocket接続
  connect: () => '/ws',
  
  // イベント: 生成完了
  generationStopped: 'generation-stopped',
} as const;

